import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  // chat: null,
  // conversationId: null,
  isInitial: true,
};

export const chatSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    /*  setChatData: (state, action) => {
      state.chat = action?.payload;
    },
    setConversationType: (state, action) => {
      state.ConversationType = action?.payload;
    },
    setConversationId: (state, action) => {
      state.conversationId = action?.payload;
    }, */
    setInitial: (state, action) => {
      state.isInitial = action?.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setChatData,
  setConversationType,
  setConversationId,
  setInitial,
} = chatSlice.actions;

export default chatSlice.reducer;
